module.exports = __webpack_public_path__ + "img/1-6.ef96e602.jpg";